module.exports = __webpack_public_path__ + "static/media/logo.31c3ebf6.jpeg";